var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file SidebarResponsive 组件
 * @author (wangzichuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { classPrefix } from '../../common/util';

import Drawer from '../Drawer';
import Sidebar from './Sidebar.js';

/**
 * 参数说明
 *
 *
 */

var SidebarResponsive = function (_Component) {
    _inherits(SidebarResponsive, _Component);

    function SidebarResponsive(props) {
        _classCallCheck(this, SidebarResponsive);

        var _this = _possibleConstructorReturn(this, (SidebarResponsive.__proto__ || Object.getPrototypeOf(SidebarResponsive)).call(this, props));

        _this.foldButtonOnClick = function () {
            if (_this.state.visible) {
                _this.setState({
                    visible: false
                });
            } else {
                _this.setState({
                    visible: true
                });
            }
        };

        _this.drawerBodyOnClick = function () {
            _this.setState({ visible: false });
        };

        _this.sidebarOnHandleClick = function (data) {
            _this.setState({ visible: false }, function () {
                setTimeout(function () {
                    _this.props.onHandleClick(data);
                }, _this.TRANSITION_TIME);
            });
        };

        _this.state = {
            visible: false
        };
        // 过渡动画时间
        _this.TRANSITION_TIME = 300;
        return _this;
    }

    _createClass(SidebarResponsive, [{
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props = this.props,
                className = _props.className,
                classPrefix = _props.classPrefix;


            var wrapperCls = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-sidebar-responsive', true), _defineProperty(_classnames, className, !!className), _classnames));
            var foldButton = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-sidebar-fold-button', true), _defineProperty(_classnames2, 'unfold', this.state.visible), _classnames2));

            return React.createElement(
                'div',
                { className: wrapperCls },
                React.createElement(
                    Drawer,
                    { visible: this.state.visible,
                        bodyOnClick: this.drawerBodyOnClick
                    },
                    React.createElement('div', { className: foldButton,
                        onClick: this.foldButtonOnClick
                    }),
                    React.createElement(Sidebar, _extends({}, this.props, {
                        fixed: false,
                        style: _extends({}, this.props.style, {
                            position: 'absolute'
                        }),
                        onHandleClick: this.sidebarOnHandleClick
                    }))
                )
            );
        }
    }]);

    return SidebarResponsive;
}(Component);

SidebarResponsive.propTypes = {
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    onHandleClick: PropTypes.func
};
SidebarResponsive.defaultProps = {
    classPrefix: classPrefix
};
export default SidebarResponsive;